import {
    AGENCY_DETAIL_RESET,
    AGENCY_DETAIL_INFO_FETCH,
    AGENCY_DETAIL_ADS_FETCH
} from './constants';
import {
    getAgencyDetails,
    getAgencyAds
} from '../services/agency'

export const startFetchAgencyDetails = (advertiseId) => {
    return (dispatch, getState) => {
        return getAgencyDetails(advertiseId)
        .then((response) => {
            dispatch(fetchAgencyDetails(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const fetchAgencyDetails = (payload) => ({
    type: AGENCY_DETAIL_INFO_FETCH,
    payload
});

export const startFetchAgencyAds = (advertiseId) => {
    return (dispatch, getState) => {
        return getAgencyAds({
                parameter: getState().agencyDetailFilters,
                id: advertiseId
            })
            .then((response) => {
                dispatch(fetchAgencyAds(response.data))
                return {
                    success: {
                        status: response.status,
                        body: response.data
                    }
                }
            })
            .catch((error) => {
                return {
                    error: {
                        status: error.response.status,
                        body: error.response.data
                    }
                }
            })
    }
};

const fetchAgencyAds = (payload) => ({
    type: AGENCY_DETAIL_ADS_FETCH,
    payload
});

export const resetAgencyDetails = (payload) => ({
    type: AGENCY_DETAIL_RESET,
    payload
});